var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBreathe = function SvgBreathe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A2C",
    fillOpacity: 0.7,
    fillRule: "evenodd",
    d: "M13.951 4.255a1.56 1.56 0 0 1-2.902 0 7.886 7.886 0 0 0-6.294 6.294 1.56 1.56 0 0 1 0 2.902 7.886 7.886 0 0 0 6.294 6.294 1.56 1.56 0 0 1 2.902 0 7.887 7.887 0 0 0 6.294-6.294 1.56 1.56 0 0 1 0-2.902 7.886 7.886 0 0 0-6.294-6.294ZM3.88 13.53a8.761 8.761 0 0 0 7.09 7.091 1.56 1.56 0 0 0 3.06 0 8.761 8.761 0 0 0 7.09-7.09 1.56 1.56 0 0 0 0-3.06 8.761 8.761 0 0 0-7.09-7.09 1.56 1.56 0 0 0-3.06 0 8.761 8.761 0 0 0-7.09 7.09 1.56 1.56 0 0 0 0 3.06Zm13.245-1.404a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgBreathe;